import { render, staticRenderFns } from "./athletes.vue?vue&type=template&id=79eac0ec&scoped=true&"
import script from "./athletes.vue?vue&type=script&lang=js&"
export * from "./athletes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79eac0ec",
  null
  
)

export default component.exports